import React, { useEffect, useState } from "react";
import './TablePedidos.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button, Col, Collapse, Input, Spinner } from "reactstrap";
import NumberFormat from "react-number-format";

const TablePedidos = ({ columns, data, readOnly, checkAll, recalculaMargemMkp, setColumn, gravaPosicaoColunas, filial_id, onBlurQtde, movimentacao, listarMovimentacao  }) => {

  const colunasDetalhes = [
    {
      titulo: 'Fantasia',
      width: '200px',
      align: 'center',
      datafield: 'fantasia'
    }, {
      titulo: 'Saldo',
      width: '100px',
      align: 'center',
      datafield: 'pedido_saldo'
    }, {
      titulo: 'Estoque Mínimo',
      width: '100px',
      align: 'center',
      datafield: 'prod_estminimo'
    }, {
      titulo: 'Total Venda',
      width: '100px',
      align: 'center',
      datafield: 'pedido_totalvenda'
    }, {
      titulo: 'Média',
      width: '100px',
      align: 'center',
      datafield: 'pedido_mediavenda'
    }, {
      titulo: 'Ciclo',
      width: '100px',
      align: 'center',
      datafield: 'ciclo'
    }, {
      titulo: 'Lista',
      width: '60px',
      align: 'center',
      datafield: 'prod_lista'
    }, {
      titulo: 'Lucro Obtido',
      width: '100px',
      align: 'center',
      datafield: 'lucro'
    }, {
      titulo: 'Pedir',
      width: '100px',
      align: 'center',
      datafield: 'pedido_qtpedido'
    }, {
      titulo: 'Última Compra',
      width: '100px',
      align: 'center',
      datafield: 'valor_ult_compra'
    }, {
      titulo: 'Últ.Pr.Líq',
      width: '100px',
      align: 'center',
      datafield: 'last_prliquido'
    }
  ]

  const [form, setForm] = useState(data);

  useEffect(() => {
    setForm(data);
  }, [data])

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }


  const onChangeInput = (e, idx) => {
    let frm = [...form];

    let value = e.target.value;

    columns.map(col => {
      if (col.datafield == e.target.name) {
        value = value.replace(',', '.');

        if (value.includes('.')) {
          if (countSubstr(value, '.') > 1) {
            value = (value.replace(/[^0-9]/g, '') / 100);
          } else {
            value = value.replace(/[^0-9.]/g, '');
          }
        } else {
          value = value.replace(/[^0-9]/g, '');
        }

        // value = Number(value).toFixed(2);
        // if(col.currency){
        //   value = value.replace('R$ ',''); 
        //   value = value.replace(',','.');
        //   value = /[0-9,.]/
        // }

        // if(col.sufix !== ""){
        //   value = value.replace(col.sufix,'');
        //   value = value.replace(',','.');
        // }
      }
    })

    frm[idx][e.target.name] = value;

    setForm(frm);

    recalculaMargemMkp();
  }

  const onChangeCB = (e, idx) => {
    let frm = [...form]

    let checked = e.target.checked;

    frm[idx].checked = checked;

    setForm(frm);
  }

  const onChangeCheckAll = (e) => {
    checkAll(e.target.checked);
    // let frm = [...form] 

    // frm.map(linha=>{
    //   linha.checked = e.target.checked
    // })

    // setForm(frm);
  }

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250
  });

  const onDragEnd = (e) => {
    // console.log(e)
    if (e.destination != null) {
      let origIdx = e.source.index;
      let destIdx = e.destination.index;

      let newCol = [];

      let oldSource = columns[origIdx];
      let oldDest = columns[destIdx];

      columns.map((col, i) => {
        if (i != origIdx) {
          newCol.push(col)
        }
        // if(i == destIdx){
        //   newCol.push(oldSource);
        //   console.log(destIdx)
        //   // newCol.push(oldDest)
        //  }else 
        // if(i == positon){
        //   newCol.push(oldDest);
        //   console.log(positon)
        // }else if((origIdx < destIdx )&&(i != positon)){
        //   newCol.push(col)
        // }else{
        //   newCol.push(col)
        // }
        // console.log(col)
      })
      newCol.splice(destIdx, 0, oldSource);
      gravaPosicaoColunas(newCol);
      setColumn(newCol);
    }
  }

  // const linhaCollapse = (linha) => {
  //   linha['lojas'].map((loja, idxLoja) =>
  //     //  return (
  //     <div
  //       key={`col-filial-${idxLoja}`}
  //       // className={[styles.columnCell,styles.rowColor]}
  //       className={'column-cell'}
  //       style={{ width: col.width, textAlign: col.align }}
  //     >{loja[idxLoja]}
  //     </div>
  //     // )
  //   )
  // }

  const CabecalhoDetalhes = () => {
    return (
      colunasDetalhes.map((coluna, idx) =>
        <div
          key={`col-header${coluna.titulo}`}
        >
          <div style={{ width: coluna.width, textAlign: coluna.align }} className={'header-column-cell'}>
            {coluna.titulo}
          </div>
        </div>
      ))
  }

  const ChangeCollapse = (produto_id) => {
    let frm = [...form];

    frm.map(linha => {
      if (linha.produto_id == produto_id) {
        linha.collapsed = !linha.collapsed;
      }
    })

    setForm(frm);
  }

  return (
    <div className="container-table">
      <div className="table-cabecalho">
      <DragDropContext 
        // onDragEnd={onDragEnd}
      >
        <Droppable
          droppableId="droppable"
          direction="horizontal"
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              // style={getListStyle(provided.isDraggingOver)}              
              // {...provided.droppableProps}
              // {...provided.placeholder}
              // {...provided}
              className={'header-row'}
            >
              {/* <div > */}

              <div
                key={`col-header-000000000000`}
              // className={'header-column-cell'}
              // style={{width:coluna.width, textAlign: coluna.align}}                          
              >
                <div style={{ width: '70px', textAlign: 'center' }} className={'header-column-cell'}>
                  {'Lojas'}
                </div>
              </div>

              {columns && columns.map((coluna, idx) => {
                if (coluna.visible == true) {
                  return (
                    <Draggable key={`drag-key-${idx}`} draggableId={`${idx}`} index={idx}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          key={`col-header-${coluna.datafield}`}
                        // className={'header-column-cell'}
                        // style={{width:coluna.width, textAlign: coluna.align}}                          
                        >
                          <div style={{ width: coluna.width, textAlign: coluna.align }} className={'header-column-cell'}>
                            {coluna.checkbox &&
                              <input
                                type="checkbox"
                                onChange={onChangeCheckAll}
                              ></input>
                            }
                            {coluna.text}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  )
                }
              }
              )}
              {/* </div> */}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      </div>

      <div className="table-body">
        {data && data.map((linha, idx) => {
          return (
            <div
              key={`row-grupo-${idx}`}
            >
              <div
                key={`linha-${idx}`}
                onClick={()=>{if(movimentacao == true){listarMovimentacao(linha.produto_id)}}}
                className={'row-grupo row-data-grid ' + 
                          ((idx % 2 == 0)  ? '' : ' row-color ') + 
                          (linha.psicotropico == 'S' ? ' row-color-psicotropico ' : '') + 
                          (linha.antimicrobiano == 'S' ? ' row-color-antimicrobiano ' : '')+
                          (linha.tipo_inclusao == 'C' ? ' row-color-faltas ' : '')+
                          (linha.tipo_inclusao  == 'I' ? ' row-color-manual ' : '')}>
                <div
                  key={`row-${idx}`}
                  style={{ display: 'flex' }}
                >
                  <div key={`group-col-111111`}>

                    {/* // coluna para abrir o collapse */}
                    <div
                      key={`col-plus-${idx}}`}
                      // className={[styles.columnCell,styles.rowColor]}
                      className={'column-cell edit-dtable'}
                      style={{ width: '70px', textAlign: 'center' }}
                    >

                      <i
                        className={"icon-filtro " + (linha.collapsed == true ? "fa fa-minus-circle" : "fa fa-plus-circle") +
                          (filial_id == '0' ? " icon-plus" : " icon-plus-inactive")
                        }
                        onClick={() => { ChangeCollapse(linha.produto_id) }}
                      >{' '}</i>
                    </div>
                  </div>
                  {columns.map((col, colIdx) =>
                    col.visible == true &&
                    <div key={`group-col-${colIdx}`}>
                      {(col.editable && !readOnly) &&
                        <div
                          key={`col-${colIdx}`}
                          // className={[styles.columnCell,styles.rowColor]}
                          className={'column-cell edit-dtable'}
                          style={{ width: col.width, textAlign: col.align }}
                        >

                          <NumberFormat
                            required
                            name="pedido_qtpedido"
                            placeholder=""
                            value={linha[columns[colIdx].datafield]}
                            //onChange={onChange('prod_prcompra')}
                            onBlur={(e) => {
                              onBlurQtde({
                                pedido_id: linha.pedido_id,
                                produto_id: linha.produto_id,
                                novo_valor: e.target.value
                              }
                              )
                            }
                            }
                            maxLength={4}
                            decimalScale={0}
                            allowNegative={false}
                            className={"input-edit-qtpedido"}
                          // prefix={"R$ "}
                          // decimalSeparator={','}
                          // fixedDecimalScale
                          />

                          {/* <Input
                          name={col.datafield}
                          value={((col.currency && linha[columns[colIdx].datafield] != "") ? 'R$ ' : '') + linha[columns[colIdx].datafield]}
                          className={"input-edit-qtpedido"}
                          style={{ textAlign: col.align }}
                          // onBlur={(e)=>{handleChangeInput(e,idx)}}
                          onChange={(e) => { onChangeInput(e, idx) }}
                        ></Input> */}
                        </div>
                      }
                      {(!col.editable || readOnly) &&
                        <div
                          key={`col-${colIdx}`}
                          // className={[styles.columnCell,styles.rowColor]}
                          className={'column-cell long-name'}
                          style={{ width: col.width, textAlign: col.align }}
                        >
                          {col.checkbox && <input type="checkbox" onChange={(evt) => { onChangeCB(evt, idx) }} checked={linha.checked}></input>}
                          {col.currency && `R$ ${linha[columns[colIdx].datafield]}`}
                          {col.sufix && `${linha[columns[colIdx].datafield]} ${col.sufix}`}
                          {!col.sufix && !col.currency && linha[columns[colIdx].datafield]}
                        </div>
                      }

                    </div>
                  )}
                </div>
                <span className={'prod-name'}>{linha.produto}</span>
                <span className={'prod-name'}>{linha.apresentacao}</span>

              </div>

              {(filial_id == '0') &&
                <Collapse isOpen={linha.collapsed}>
                  <div
                    className={'header-row'}
                  >
                    <CabecalhoDetalhes></CabecalhoDetalhes>
                  </div>

                  {linha['lojas'].map((loja, idxLoja) =>

                    <div
                      key={`row-grupo-detalhes-${idxLoja}`}
                      className={'row-grupo row-data-grid ' + ((idxLoja % 2 == 0) ? '' : 'row-color')}>
                      <div
                        key={`row-${idxLoja}`}
                        style={{ display: 'flex' }}
                      >

                        {colunasDetalhes.map((coluna, idxCol) =>

                          // <div 
                          //  key={`group-col-${idxCol}`}
                          // >
                          <div
                            key={`col-det-${idxCol}`}
                            // className={[styles.columnCell,styles.rowColor]}
                            className={'column-cell'}
                            style={{ width: coluna.width, textAlign: coluna.align }}
                          >
                            {coluna.datafield == 'pedido_qtpedido' &&
                              <span className="d-flex justify-content-center" >
                                <NumberFormat
                                  required
                                  name="pedido_qtpedido"
                                  placeholder=""
                                  value={loja[coluna.datafield]}
                                  //onChange={onChange('prod_prcompra')}
                                  onBlur={(e) => {
                                    onBlurQtde({
                                      pedido_id: loja.pedido_id,
                                      produto_id: linha.produto_id,
                                      novo_valor: e.target.value
                                    },
                                      loja.filial_id
                                    )
                                  }
                                  }
                                  maxLength={4}
                                  decimalScale={0}
                                  allowNegative={false}
                                  className={"input-edit-qtpedido"}
                                // prefix={"R$ "}
                                // decimalSeparator={','}
                                // fixedDecimalScale
                                />
                                {/* <Input className="input-edit-qtpedido" value={loja[coluna.datafield]}>
                              </Input> */}
                              </span>}
                            {coluna.datafield != 'pedido_qtpedido' && <span className={'prod-name'}>{loja[coluna.datafield]}</span>}
                          </div>
                          // </div>
                        )
                        }

                      </div>


                    </div>
                  )}

                </Collapse>
              }


            </div>


          )
        }
        )}
      </div>
    </div >


    // <div className={styles.containerTable}>
    //   <table>
    //     <thead>
    //       <tr>
    //         {columns.map(coluna =>
    //           <th
    //             key={coluna.dataField}
    //             className={styles.headerColumnCell}>
    //             {coluna.text}
    //           </th>
    //         )}
    //       </tr>
    //     </thead>

    //     <tbody>
    //       {data.map((linha, idx) =>

    //         <tr
    //           key={`row${idx}`}
    //         >
    //           {columns.map((col, colIdx) =>
    //               <td
    //                 key={`col${colIdx}`}
    //                 className={[styles.columnCell]}
    //               >
    //                 <div>
    //                   <span style={{display:"block"}}>{linha[columns[colIdx].dataField]}</span>
    //                   {colIdx == 0 &&
    //                     <span style={{width:'200px',display:"block"}}>{linha.produto}</span>
    //                   }
    //                 </div>
    //               </td>
    //           )}
    //         </tr>

    //       )}
    //     </tbody>

    //   </table>
    // </div>
  )
}

export default TablePedidos;